var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.showTitle
        ? _c("div", { staticClass: "d-flex justify-space-between" }, [
            _c("p", { staticClass: "font-weight-black" }, [
              _vm.allowEdit ? _c("span", [_vm._v("EDITAR")]) : _vm._e(),
              _vm._v(" ESTADO"),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-form",
        { ref: "formState", attrs: { "lazy-validation": "" } },
        [
          _c(
            "v-row",
            { staticClass: "fill-height px-3 pt-2" },
            [
              _c(
                "v-col",
                { attrs: { cols: "12" } },
                [
                  _c("v-autocomplete", {
                    staticClass: "pt-2",
                    staticStyle: { "font-size": "15px" },
                    attrs: {
                      value: _vm.getTicket.state,
                      items: _vm.getActiveTicketStates,
                      readonly:
                        _vm.getTicketStatesMap[_vm.getTicket.state].final,
                      rules: _vm.stateCustomRules,
                      "item-text": "name",
                      "item-value": "id",
                      label: "Estado",
                    },
                    model: {
                      value: _vm.state,
                      callback: function ($$v) {
                        _vm.state = $$v
                      },
                      expression: "state",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _vm.getTicket.state === _vm.$ticketStates.ORDEN_CREADA &&
              _vm.getTicket.order_id &&
              [
                _vm.$roles.SUPER_ADMIN,
                _vm.$roles.ADMIN,
                _vm.$roles.ENTREPRENEUR,
              ].includes(_vm.getAgent.role)
                ? _c(
                    "v-col",
                    { staticClass: "pt-0 text-right", attrs: { cols: "12" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            text: "",
                            small: "",
                            to: {
                              name: "order_detail",
                              params: { id: _vm.getTicket.order_id },
                            },
                            target: "_blank",
                            color: "primary",
                          },
                        },
                        [
                          _c(
                            "v-icon",
                            { staticClass: "pr-2", attrs: { "x-small": "" } },
                            [_vm._v(" fas fa-external-link-alt ")]
                          ),
                          _vm._v(" Ver detalle de la orden\n        "),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.responseMessage
                ? _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("v-alert", { attrs: { text: "", type: "error" } }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.responseMessage) +
                            "\n        "
                        ),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.allowEdit
                ? _c(
                    "v-col",
                    { staticClass: "text-center", attrs: { cols: "12" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            loading: _vm.loading,
                            small: "",
                            rounded: "",
                            color: "primary",
                          },
                          on: { click: _vm.onSave },
                        },
                        [_vm._v(" Guardar ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { small: "", rounded: "" },
                          on: { click: _vm.onCancel },
                        },
                        [_vm._v(" Cancelar ")]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }